import ZTableCol from './ZTableCol.vue'

export default ZTableCol
